import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { RiArrowDownSLine } from "@remixicon/react";
import ShippingPipelinePerformance from "components/Shipping/Analytics/PipelinePerformanceChartsCollection";
import React from "react";

import FulfillmentsDeliveredStats from "components/Shipping/Analytics/FulfillmentsDeliveredStats";

const ShippingInsightsPage: React.FC = () => {
  document.title = "Executive Insights - Shipping";

  return (
    <Box sx={{ p: 4 }}>
      <Typography
        variant="h4"
        component="h1"
        gutterBottom
        sx={{ marginBottom: "35px" }}
      >
        Shipping Insights
      </Typography>

      <Accordion>
        <AccordionSummary
          expandIcon={<RiArrowDownSLine />}
          aria-controls="pipeline-performance-metrics"
          id="pipeline-performance-metrics-header"
        >
          <Typography variant="h5">Pipeline Performance</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 2 }}>
          <ShippingPipelinePerformance />
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<RiArrowDownSLine />}
          aria-controls="completed-stats-content"
          id="completed-stats-header"
        >
          <Typography variant="h5">Fulfillments Delivered</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 2 }}>
          <FulfillmentsDeliveredStats />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default ShippingInsightsPage;
